// FileIO v1.0 (ES6 module)

const ReadMethods = {
	TEXT: 'readAsText',
	DATA_URL: 'readAsDataURL'
};

const save = {
	data: (data, filename, type) => {
		const blob = new Blob([data], { type: type || 'text/plain' });
		console.log(blob);
		save.blob(blob, filename);
	},

	json: (data, filename) => {
		try {
			if (typeof data !== 'string') {
				data = JSON.stringify(data);
			}
			filename = save._extendFilename(filename, 'json');
			save.data(data, filename, 'application/json');
		} catch (e) {
			console.error(e);
		}
	},

	blob: (blob, filename) => {
		if (navigator.msSaveBlob) {
			navigator.msSaveBlob(blob, filename);
		} else {
			const url = URL.createObjectURL(blob);
			save._downloadDataUrl(url, filename);
		}
	},

	file: (file, filename) => {
		if (navigator.msSaveBlob) {
			navigator.msSaveBlob(file, filename);
		} else {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.addEventListener('load', save._processedFile(filename));
		}
	},

	csv: (data, filename, transpose, sanitise) => {
		const rows = save._csvPrepareData(data, transpose, sanitise);
		filename = save._extendFilename(filename, 'csv');
		save.data(rows, filename, 'text/csv');
	},

	_csvPrepareData: (data, transpose, sanitise) => {
		let rows = save._csvShapeData(data, transpose);
		rows = save._csvEscape(rows, sanitise);
		rows = rows.map(row => row.join(',')).join('\n');
		return rows;
	},

	_csvShapeData: (data, transpose) => {
		const rows = [];
		let maxLength = 0;
		for (let i = 0; i < data.length; i++) {
			maxLength = Math.max(maxLength, data[i].length);
		}
		const iMax = transpose ? maxLength : data.length;
		const jMax = transpose ? data.length : maxLength;
		for (let i = 0; i < iMax; i++) {
			const row = [];
			for (let j = 0; j < jMax; j++) {
				let cellValue = transpose ? data[j][i] : data[i][j];
				if (typeof cellValue === 'undefined') cellValue = '';
				row.push(cellValue);
			}
			rows.push(row);
		}
		return rows;
	},

	_csvEscape: (rows, sanitise) => {
		for (let i = 0; i < rows.length; i++) {
			for (let j = 0; j < rows[i].length; j++) {
				let cell = rows[i][j];
				if (typeof cell === 'undefined') cell = '';
				else if (typeof cell !== 'string') cell = '' + cell;
				if (sanitise && /^[=\-+@]/.test(cell)) {
					cell = '\t' + cell;
				}
				if (/,|"|\n/.test(cell)) {
					cell = '"' + cell.replace(/"/g, '""') + '"';
				}
				rows[i][j] = cell;
			}
		}
		return rows;
	},

	_processedFile: filename => function () {
		save._downloadDataUrl(this.result, filename);
	},

	_downloadDataUrl: (dataUrl, filename) => {
		const link = document.createElement('a');
		link.href = dataUrl;
		link.download = filename;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(dataUrl);
	},

	_extendFilename: (filename, extension) => {
		const testPattern = new RegExp('\\.' + extension + '$');
		if (!testPattern.test(filename)) {
			filename += '.' + extension;
		}
		return filename;
	}
};

const load = {
	text: fileLoadedCallback => {
		load._file(fileLoadedCallback, ReadMethods.TEXT);
	},

	image: fileLoadedCallback => {
		load._file(fileLoadedCallback, ReadMethods.DATA_URL);
	},

	_file: (fileLoadedCallback, readMethod) => {
		const fileInput = document.createElement('input');
		fileInput.type = 'file';
		fileInput.addEventListener('change', load._loadSelectedFile(fileInput, fileLoadedCallback, readMethod));
		fileInput.click();
	},

	_loadSelectedFile: (fileInput, fileLoadedCallback, readMethod) => e => {
		const file = fileInput.files[0];
		const reader = new FileReader();
		reader.onload = load._fileLoaded(fileLoadedCallback);
		reader[readMethod](file);
	},

	_fileLoaded: fileLoadedCallback => e => {
		const reader = e.target;
		if (reader.readyState === 2) {
			fileLoadedCallback(reader.result);
		}
	}
};

const fileIO = {
	save,
	load
};

export default fileIO;
